export enum EGridLayout {
  Row = 'Row',
  Grid = 'Grid',
}

export const gridColumnGap = 5;
export const gridRowGap = 12;

export const baseGridStyles = {
  height: '100%',
  width: '100%',
  display: 'grid',
  overflow: 'hidden',
};
